import React, { useState } from "react";

export default function SearchBar({ onSearch }) {
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = () => {
    onSearch(searchQuery);
  };

  return (
    <div className="d-flex align-items-center justify-content-center mt-4 mb-4">
      <div className="input-group search-container" style={{ width: "50%" }}>
        <input
          type="text"
          className="form-control rounded-pill shadow-none transition-input"
          placeholder="Search Package..."
          aria-label="Search"
          aria-describedby="search-button"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        <button
          className="btn btn-primary rounded-pill ml-2 shadow-sm transition-button"
          id="search-button"
          onClick={handleSearch}
        >
          Search
        </button>
      </div>
    </div>
  );
}